import { type PreviewStanding } from "../content/preview-competition.types";
const liveWindowMultiple = 3;
const liveWindowFloorMs = 10 * 60 * 1000;
const liveWindowCeilingMs = 4 * 60 * 60 * 1000;
function liveWindowMs(roundMinutes: number | null): number {
  if (roundMinutes === null) return liveWindowCeilingMs;

  const scaled = roundMinutes * 60 * 1000 * liveWindowMultiple;
  return Math.min(Math.max(scaled, liveWindowFloorMs), liveWindowCeilingMs);
}
export function isLive({
  standings,
  newestCompletedAt,
  roundMinutes,
  now = Date.now(),
}: {
  standings: readonly PreviewStanding[];
  newestCompletedAt: string | null;
  roundMinutes: number | null;
  now?: number;
}): boolean {
  if (standings.length === 0 || !newestCompletedAt) return false;

  const at = new Date(newestCompletedAt).getTime();
  return !Number.isNaN(at) && now - at <= liveWindowMs(roundMinutes);
}
